import { CountryFlags, Colors } from '..';
const {
  blue_lightest,
  blue,
  plum_electric,
  plum_electric_active,
  sec_green,
  sec_green_lighter,
  new_grey_light,
  new_grey_lighter
} = Colors;
export const getAttendanceEmployment = (attendanceInHouse, attendanceRemote) => {
  const inHouse = attendanceInHouse ? 'In-House' : '';
  const remote = attendanceRemote ? 'Remote' : '';
  const slash = inHouse && remote ? ' / ' : '';
  return "".concat(inHouse).concat(slash).concat(remote);
};
export const getAttendance = (attendanceOnline, attendanceOnCampus) => {
  const online = attendanceOnline ? 'Online' : '';
  const onCampus = attendanceOnCampus ? 'On Campus' : '';
  const slash = online && onCampus ? ' / ' : '';
  return "".concat(onCampus).concat(slash).concat(online);
};
export const getCommitment = commitment => commitment === 'PART_TIME' ? 'Part Time' : 'Full Time';
export const getAttendanceCourse = (attendanceOnline, attendanceInPerson) => {
  const online = attendanceOnline ? 'Online' : '';
  const inPerson = attendanceInPerson ? 'In Person' : '';
  const slash = online && inPerson ? ' / ' : '';
  return "".concat(inPerson).concat(slash).concat(online);
};
export const getCountryIdByName = name => {
  const associatedKey = Object.keys(CountryFlags).find(key => CountryFlags[key].name === name && key);
  if (!name || !associatedKey) {
    throw new Error('getCountryIdByName function expects a valid argument');
  }
  return associatedKey;
};
export const getRoles = function () {
  let roles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Order of the role values provided in the roles argument matters
  // [roleCreative, roleDemonstrator, rolePresenter, roleTeamLeader]
  const activeRolesIndex = [];
  roles.forEach((val, index) => val && activeRolesIndex.push(index));
  const seperator = activeRolesIndex.length - 1;
  const renderRoles = activeRolesIndex.map((item, index) => "\n      ".concat(item === 0 ? 'Team Leader' : '', "\n      ").concat(item === 1 ? 'Presenter' : '', "\n      ").concat(item === 2 ? 'Demonstrator' : '', "\n      ").concat(item === 3 ? 'Creative' : '', "\n      ").concat(seperator > index ? ' • ' : '', "\n    "));
  return renderRoles;
};
const SEPARATOR_CHARACTER = '•';
export const getActivityDetailsBulletPoints = activityKeyBooleansCollection => Object.entries(activityKeyBooleansCollection).filter(_ref => {
  let [_key, value] = _ref;
  return value;
}).map(_ref2 => {
  let [key] = _ref2;
  return key.charAt(0).toUpperCase() + key.slice(1);
}).join(" ".concat(SEPARATOR_CHARACTER, " "));
export const getProgressIndicatorStyles = _ref3 => {
  let {
    progressType,
    progress,
    percentageComplete,
    isCurrent
  } = _ref3;
  switch (progressType) {
    case 'INDEFINITE':
      return isCurrent ? {
        progressIndicatorCircleColor: plum_electric_active,
        progressIndicatorColor: plum_electric,
        status: 'Current',
        icon: 'progress'
      } : {
        progressIndicatorCircleColor: sec_green_lighter,
        progressIndicatorColor: sec_green,
        status: 'Completed',
        icon: 'complete'
      };
    case 'TIME_BOX':
      if (percentageComplete !== null && percentageComplete < 100) {
        return {
          progressIndicatorCircleColor: new_grey_lighter,
          progressIndicatorColor: new_grey_light,
          status: 'Incomplete',
          icon: 'incomplete'
        };
      }
      if (progress >= 100 || percentageComplete >= 100) {
        return {
          progressIndicatorCircleColor: sec_green_lighter,
          progressIndicatorColor: sec_green,
          status: 'Completed',
          icon: 'complete'
        };
      }
      return {
        progressIndicatorCircleColor: blue_lightest,
        progressIndicatorColor: blue,
        status: 'In Progress',
        icon: 'none'
      };
    case 'TIME_STAMP':
      return {
        progressIndicatorCircleColor: sec_green_lighter,
        progressIndicatorColor: sec_green,
        status: 'Completed',
        icon: 'complete'
      };
    default:
      return {
        progressIndicatorColor: sec_green,
        progressIndicatorCircleColor: sec_green_lighter,
        status: 'Completed',
        icon: 'complete'
      };
  }
};